const FilterType = Object.freeze({
  PRIMARY_TERMS: 'PrimaryTerms',
  INCLUDE_TERMS: 'IncludeTerms',
  EXCLUDE_TERMS: 'ExcludeTerms',
  LANGUAGE: 'Language',
  INCLUDE_DOMAINS: 'IncludeDomains',
  EXCLUDE_DOMAINS: 'ExcludeDomains',
  INCLUDE_GEOGRAPHIES: 'IncludeGeographies',
  EXCLUDE_GEOGRAPHIES: 'ExcludeGeographies',
  INCLUDE_AUTHORS: 'IncludeAuthors',
  EXCLUDE_AUTHORS: 'ExcludeAuthors',
  INCLUDE_POSTS: 'IncludePosts',
  EXCLUDE_POSTS: 'ExcludePosts',
  SOURCES: 'Sources',
  POST_TYPE: 'PostType',
  GENDER: 'Gender',
  DATE_RANGE: 'DateRange',
  POSITIVE_INSIGHTS: 'PositiveInsights',
  NEGATIVE_INSIGHTS: 'NegativeInsights',
  NEUTRAL_INSIGHTS: 'NeutralInsights',
  HIDE_INSIGHTS: 'HideInsights',
  TOPIC_QUERY: 'TopicQuery',
  INCLUDE_SENTIMENT_DRIVER: 'IncludeSentimentDriver',
  EXCLUDE_SENTIMENT_DRIVER: 'ExcludeSentimentDriver',
  INCLUDED_LANGUAGES: 'IncludedLanguages',
  EXCLUDED_LANGUAGES: 'ExcludedLanguages',
  ANNOTATION: 'Annotation',
  OWNED_EARNED: 'OwnedEarned',
  ORGANIC_PAID_POST_TYPES: 'OrganicPaidPostTypes',
  FOLLOWERS: 'Followers',
  INCLUDE_USER_TAGS: 'IncludeUserTags',
  EXCLUDE_USER_TAGS: 'ExcludeUserTags',
  SENTIMENTS: 'Sentiments',
  INCLUDED_PROFESSIONS: 'IncludedProfessions',
  EXCLUDED_PROFESSIONS: 'ExcludedProfessions',
  INCLUDED_INTERESTS: 'IncludedInterests',
  EXCLUDED_INTERESTS: 'ExcludedInterests',
  INCLUDED_EMOJIS: 'IncludedEmojis',
  EXCLUDED_EMOJIS: 'ExcludedEmojis',
  THEME_QUERY: 'ThemeQuery',
  FACEBOOK_CHANNEL: 'FacebookChannel',
  TWITTER_CHANNEL: 'TwitterChannel',
  INSTAGRAM_CHANNEL: 'InstagramChannel',
  YOU_TUBE_CHANNEL: 'YouTubeChannel',
  OTHER_CHANNEL: 'OtherChannel',
  FACEBOOK_PAID_POSTS: 'FacebookPaidPosts',
  INCLUDED_BIO_TEXTS: 'IncludedBioTexts',
  EXCLUDED_BIO_TEXTS: 'ExcludedBioTexts',
  VERIFIED_USERS: 'VerifiedUsers',
  MEDIA_TYPES: 'MediaTypes',
  DAY_HOUR: 'DayHour',
  GEO_FENCING: 'GeoFencing',
  CV_LOGOS: 'CvLogos',
  OCR: 'OCR',
  TOPIC_GEO_FENCING: 'TopicGeoFencing',
  SENTIMENT_FOCUS: 'SentimentFocus',
  INCLUDED_CHANNELS: 'IncludedChannels',
  EXCLUDED_CHANNELS: 'ExcludedChannels',
  INCLUDED_META_TAGS: 'IncludedMetaTags',
  EXCLUDED_META_TAGS: 'ExcludedMetaTags',
  INCLUDED_PRODUCT_HIERARCHY: 'IncludedProductHierarchy',
  EXCLUDED_PRODUCT_HIERARCHY: 'ExcludedProductHierarchy',
  INCLUDED_META_TAGS_INTERNAL: 'IncludedMetaTagsInternal',
  EXCLUDED_META_TAGS_INTERNAL: 'ExcludedMetaTagsInternal',
  INCLUDED_PRODUCT_HIERARCHY_INTERNAL: 'IncludedProductHierarchyInternal',
  EXCLUDED_PRODUCT_HIERARCHY_INTERNAL: 'ExcludedProductHierarchyInternal',
  CHANNELS_INCLUDE_TERMS: 'ChannelsIncludeTerms',
  CHANNELS_EXCLUDE_TERMS: 'ChannelsExcludeTerms',
  CHANNELS_INCLUDE_AUTHORS: 'ChannelsIncludeAuthors',
  CHANNELS_EXCLUDE_AUTHORS: 'ChannelsExcludeAuthors',
  STAR_RATINGS: 'StarRatings',
  SURVEY_SCORES: 'SurveyScores',
  NET_PROMOTER_SCORES: 'NetPromoterScores',
  INCLUDE_LXNX_SOURCES: 'IncludeLxnxSources',
  EXCLUDE_LXNX_SOURCES: 'ExcludeLxnxSources',
  INCLUDE_LXNX_SUBJECTS: 'IncludeLxnxSubjects',
  EXCLUDE_LXNX_SUBJECTS: 'ExcludeLxnxSubjects',
  LXNX_SOURCE_TYPES: 'LxnxSourceTypes'
})
export default FilterType
export type FilterTypeStrings = typeof FilterType[keyof typeof FilterType]
// RESERVE BELOW
